import React from 'react';

import Decimal from 'decimal.js';
import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_CUSTOMER_COMMISSION, LINE_ITEM_PROVIDER_COMMISSION } from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';
import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

const lineItemsTotal = (lineItems, marketplaceCurrency) => {
  const amount = lineItems.reduce((total, item) => {
    return total.plus(item.lineTotal.amount);
  }, new Decimal(0));
  const currency = lineItems[0] ? lineItems[0].lineTotal.currency : marketplaceCurrency;
  return new Money(amount, currency);
};

/**
 * A component that renders the provider commission refund as a line item.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {boolean} props.isProvider - Whether the provider is the one receiving the commission
 * @param {string} props.marketplaceName - The name of the marketplace
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const LineItemProviderCommissionRefundMaybe = (props) => {
  const { lineItems, isProvider, marketplaceName, intl, marketplaceCurrency } = props;

  const refund = lineItems.find(
    (item) => item.code === LINE_ITEM_PROVIDER_COMMISSION && item.reversal
  );

  const customerCommissionRefund = lineItems.find(
    (item) =>
      item.code === LINE_ITEM_CUSTOMER_COMMISSION &&
      item.includeFor.includes('provider') &&
      item.reversal
  );

  const totalRefund = customerCommissionRefund
    ? lineItemsTotal([customerCommissionRefund, refund], marketplaceCurrency)
    : refund?.lineTotal;

  return isProvider && refund ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.refundProviderFee" values={{ marketplaceName }} />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, totalRefund)}</span>
    </div>
  ) : null;
};

export default LineItemProviderCommissionRefundMaybe;
